import IButtonData from "../../shared/interfaces/button.interface";

export const BUTTON: IButtonData = {
	id: 'take-attendance',
    variant: 'contained',
    color: 'success',
    textButton: "Registrar",
    size:'small',
}